export default {
  EditorMenuClicked: 'EditorMenuClicked',
  ClearProject: 'ClearProject',

  ZoomIn: 'ZoomIn',
  ZoomOut: 'ZoomOut',

  FullScreen: 'FullScreen',

  ShowPopup: 'ShowPopup',
  HidePopup: 'HidePopup',

  ShowDownloadScheme: 'ShowDownloadScheme',
  PrepareImageForDownload: 'PrepareImageForDownload',

  SiteHeaderBackButtonClicked: 'SiteHeaderBackButtonClicked',

  CreateStageImages: 'OrderButtonClicked',
  StageImagesReady: 'StageImagesReady',

  SelectItemInEditor: 'SelectItemInEditor',

  RIGHT_MOUSE_BUTTON_DOWN: 'RIGHT_MOUSE_BUTTON_DOWN',
  RIGHT_MOUSE_BUTTON_UP: 'RIGHT_MOUSE_BUTTON_UP',
  MOUSE_DOWN_ON_3D_SCENE: 'MOUSE_DOWN_ON_3D_SCENE',

  ShowTooltips: 'ShowTooltips',
  HideTooltips: 'HideTooltips',
  TooltipPoint: 'TooltipPoint',

  ShowSmallTooltip: 'ShowSmallTooltip',

  KrausEquipmentSelectOptions: 'KrausEquipmentSelectOptions',

  ShowDeliveryMap: 'ShowDeliveryMap'
}
